import { render, staticRenderFns } from "./ButtonWithPopover.vue?vue&type=template&id=2d567ccb&"
import script from "./ButtonWithPopover.ts?vue&type=script&lang=js&"
export * from "./ButtonWithPopover.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports